const AWSS3DocumentType = {
    AttendanceCorrectionsAttachment: 'attendancecorrectionsattachment',
    Annualization: 'annualization',
    BIR1601: 'bir1601',
    BIR1603: 'bir1603',
    BIR1604: 'bir1604',
    BIR2316: 'bir2316',
    CompanyAnnouncement: 'companyannouncement',
    CompensationAndBenefits: 'compensationandbenefits',
    eDocuments: 'edocuments',
    HR201: 'hr201',
    DepositSlips: 'depositslips',
    OvertimeAttachment: 'overtimeattachment',
    Paylips: 'payslips',
    PrintedInvoice: 'printedinvoice',
    ProofOfPayment: 'proofofpayment',
    Reimbursements: 'reimbursements',
    SOA: 'soa',
    TimeOffAttachment: 'timeoffattachment'
}

export default AWSS3DocumentType